import isFunction from '../predicates/isFunction';

function applyCurry(fn: unknown, arg: unknown): unknown {
  if (!isFunction(fn)) {
    return fn;
  }
  return fn.length > 1 ? fn.bind(null, arg) : fn.call(null, arg);
}

/**
 * Takes a function and it will return another function
 * that can be called in any form
 * until all arguments have been provided.
 */

// curry :: ((a, b, c) -> d) -> a -> b -> c -> d
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function curry<T extends(...args: any[]) => any>(fn: T): any {
  return (...xs: unknown[]) => {
    const args = xs.length ? xs : [ undefined ];

    if (args.length < fn.length) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return curry(Function.bind.apply(fn, [ null, ...args ] as any));
    }

    const val = args.length === fn.length ? fn(...args) : args.reduce(applyCurry, fn);

    if (isFunction(val)) {
      return curry(val);
    }

    return val;
  };
}

export default curry;
